import React from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { makeStyles } from '@material-ui/core/styles';
import { lightGray, darkBlue } from '../../Constants/Colors';
import { useSelector } from 'react-redux';
import { getFormattedPrice } from '../../Reducers/App/Selectors';

const useStyles = makeStyles({
  priceBox: {
    backgroundColor: lightGray,
    height: 80,
    padding: '0 1.5rem',
    fontSize: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    '& $priceValue': {
      fontSize: '1em',
    },
    '& $vatNotice': {
      fontSize: '0.5em',
    },
  },
  priceValue: {
    color: darkBlue,
  },
  vatNotice: {
    color: darkBlue,
  },
});

export const PriceBox = () => {
  const price = useSelector(getFormattedPrice);
  const classes = useStyles();

  return (
    <div className={classes.priceBox}>
      <div className={classes.priceValue}>{price}</div>
      <div className={classes.vatNotice}>{t('vatNotice')}</div>
    </div>
  );
};

export default PriceBox;
